import { Package, FolderArchive, FileText, Download, X } from 'lucide-react';

export function ExportPackageModal({ show, onClose, exporting, result, onDownload }) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center" data-testid="package-modal-overlay">
      <div className="bg-card border border-border rounded-sm w-full max-w-lg mx-4 animate-fade-in" data-testid="package-modal">
        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-border">
          <div className="flex items-center gap-2">
            <Package className="w-5 h-5 text-violet-400" />
            <span className="font-heading font-bold text-sm uppercase tracking-wider text-foreground">Digitization Export Package</span>
          </div>
          <button onClick={onClose} className="p-1 hover:bg-secondary rounded text-muted-foreground hover:text-foreground transition-colors" data-testid="close-package-modal">
            <X className="w-4 h-4" />
          </button>
        </div>

        {/* Body */}
        <div className="p-5">
          {exporting ? (
            <div className="flex flex-col items-center py-8" data-testid="package-generating">
              <div className="relative mb-4">
                <FolderArchive className="w-10 h-10 text-violet-400" />
                <div className="absolute inset-0 w-10 h-10 border-2 border-violet-500/30 rounded-full animate-ping" />
              </div>
              <p className="font-heading font-bold text-sm uppercase tracking-wider text-foreground">Generating Package</p>
              <p className="text-xs text-muted-foreground mt-1">Bundling drawings, models, and reports...</p>
            </div>
          ) : result?.error ? (
            <div className="py-6 text-center" data-testid="package-error">
              <p className="text-rose-400 font-mono text-sm">{result.error}</p>
              <button onClick={onClose} className="mt-4 px-4 py-2 text-xs font-heading uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
                Close
              </button>
            </div>
          ) : result ? (
            <div data-testid="package-ready">
              <div className="bg-card border border-border rounded-sm p-4 mb-4">
                <p className="font-heading font-bold text-xs uppercase tracking-wider text-emerald-400 mb-3">Package Ready</p>
                <div className="space-y-2 text-xs font-mono">
                  <div className="flex justify-between text-muted-foreground">
                    <span>Filename</span>
                    <span className="text-foreground">{result.filename}</span>
                  </div>
                  <div className="flex justify-between text-muted-foreground">
                    <span>Size</span>
                    <span className="text-foreground">{(result.size_bytes / 1024).toFixed(1)} KB</span>
                  </div>
                </div>
              </div>

              <div className="bg-card border border-border rounded-sm p-4 mb-4">
                <p className="font-heading font-bold text-[10px] uppercase tracking-wider text-muted-foreground mb-2">Package Contents</p>
                <div className="space-y-1.5 text-[11px] font-mono text-muted-foreground">
                  <div className="flex items-center gap-2"><FolderArchive className="w-3 h-3 text-blue-400" /> <span>sheets/ <span className="text-muted-foreground">- All processed drawings (original, enhanced, annotated, clean)</span></span></div>
                  <div className="flex items-center gap-2"><FolderArchive className="w-3 h-3 text-violet-400" /> <span>geometry/ <span className="text-muted-foreground">- Room polygon data per sheet (JSON)</span></span></div>
                  <div className="flex items-center gap-2"><FileText className="w-3 h-3 text-primary" /> <span>building_model.json <span className="text-muted-foreground">- Normalized building model</span></span></div>
                  <div className="flex items-center gap-2"><FileText className="w-3 h-3 text-emerald-400" /> <span>manifest.json <span className="text-muted-foreground">- Full extraction manifest</span></span></div>
                  <div className="flex items-center gap-2"><FileText className="w-3 h-3 text-foreground" /> <span>REPORT.md <span className="text-muted-foreground">- Summary report with tables</span></span></div>
                </div>
              </div>

              <button
                onClick={onDownload}
                data-testid="download-package-btn"
                className="w-full flex items-center justify-center gap-2 border-l-2 border-violet-500 bg-violet-600/10 hover:bg-violet-600/20 text-violet-400 font-heading font-bold uppercase tracking-wider text-sm h-11 px-6 transition-colors"
              >
                <Download className="w-4 h-4" />
                Download Package ({(result.size_bytes / 1024).toFixed(1)} KB)
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}
